import { RecordType, VehicleBodyTypes, VehicleMakeTypes } from '../constants/parameters';

export enum FleetSortOrder {
  CAPTURE_TIME_ASC = 'captureTime asc',
  CAPTURE_TIME_DESC = 'captureTime desc',
  PLATE_NUMBER_ASC = 'plateNumber asc',
  PLATE_NUMBER_DESC = 'plateNumber desc',
  RECORD_TYPE_ASC = 'recordType asc',
  RECORD_TYPE_DESC = 'recordType desc',
}

export enum FleetRecordType {
  ALL = 'all',
  HIT = 'hit',
  READ = 'read',
}

export const RECORD_TYPE_TO_FLEET_RECORD_TYPE: Record<RecordType, FleetRecordType> = {
  [RecordType.ALL]: FleetRecordType.ALL,
  [RecordType.HIT]: FleetRecordType.HIT,
};

/**
 * Interface for Fleet LPR search parameters.
 *
 * Backend:
 * - Path: src/integrations/connectors/axon/fleet_ps/serializers.py
 * - Class: PlateSearchSerializer
 */
export interface IFsLprFleetParameters {
  includeFacets?: boolean;
  // Pagination/sorting
  sort?: FleetSortOrder;
  sortValues?: string; // {timestamp,uuid}
  limit?: string;

  // General
  plate?: string;
  fromDate?: string;
  toDate?: string;
  searchReason: string;

  // Additional
  recordType?: FleetRecordType;
  assignedUserIds?: string; // comma separated user IDs
  plateState?: string;
  plateStateConfidence?: number;
  /**
   * commas seperated polygon. fleet supports up to 20 points
   * @url https://axon.quip.com/XNl4AMLfwayD/ALPR-Provider-Geo-Search-Limitations#temp:C:SJb8b46a8ad6c604d3aa50fea1a1
   */
  inBbox?: string;
  vehicleColor?: string; // comma separated VehicleColorTypes
  vehicleMake?: VehicleMakeTypes;
  vehicleBody?: VehicleBodyTypes;
  vehicleName?: string;

  cameraNames?: string; // comma separated camera names
  cameraVendors?: string; // comma separated camera vendors (for SDM)
  cameraModels?: string; // comma separated camera models (for SDM)
  topRack?: boolean;
  windowStickers?: boolean;
  bumperStickers?: boolean;
}
